import { Award } from 'lucide-react';

import { formatDate } from '@/lib/format';

interface CertificateDisplayProps {
  managerName: string;
  organizationName: string;
  completionDate: string;
  certificateId: string;
}

export function CertificateDisplay({
  managerName,
  organizationName,
  completionDate,
  certificateId,
}: CertificateDisplayProps) {
  return (
    <div className="mx-auto max-w-2xl rounded-lg border-4 border-double border-primary/30 bg-white p-8 text-center shadow-lg sm:p-12">
      <Award className="mx-auto mb-4 h-12 w-12 text-primary" />
      <h1 className="text-3xl font-bold text-primary">Certificate of Completion</h1>
      <p className="mt-2 text-lg text-muted-foreground">
        Menopause Awareness in the Workplace
      </p>
      <div className="my-8">
        <p className="text-sm text-muted-foreground">This certifies that</p>
        <p className="my-2 text-2xl font-bold">{managerName}</p>
        <p className="text-sm text-muted-foreground">
          has successfully completed the Metaonia Manager Training Program
        </p>
        <p className="mt-1 text-xs text-muted-foreground">
          comprising 6 scenario-based modules on supporting employees experiencing menopause
        </p>
      </div>
      <div className="space-y-1 text-sm text-muted-foreground">
        <p>{formatDate(completionDate)}</p>
        <p>{organizationName}</p>
      </div>
      <div className="mt-8 border-t pt-4">
        <p className="text-xs text-muted-foreground">Certificate ID: {certificateId}</p>
        <p className="mt-1 text-xs font-medium text-primary">Metaonia</p>
      </div>
    </div>
  );
}
